/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Noresults1Inputs */

const zh_common_noresults1 = /** @type {(inputs: Common_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无匹配结果`)
};

const en_common_noresults1 = /** @type {(inputs: Common_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results found`)
};

const es_common_noresults1 = /** @type {(inputs: Common_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin resultados`)
};

/**
* | output |
* | --- |
* | "No results found" |
*
* @param {Common_Noresults1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const common_noresults1 = /** @type {((inputs?: Common_Noresults1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Noresults1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_common_noresults1(inputs)
	if (locale === "en") return en_common_noresults1(inputs)
	return es_common_noresults1(inputs)
});
export { common_noresults1 as "common_noResults" }